import { cn } from "@/lib/utils";

/**
 * Zupa for Logistics wordmark lockup.
 * "ZUPA" in Archivo Black + "FOR LOGISTICS" beneath in Saira Stencil One (cargo orange,
 * letterspaced). On ink surfaces pass `inverted` so ZUPA renders paper; the sub-mark stays
 * cargo orange on any background. Height-driven: pass an `h-*` class and the width follows.
 * See .flow/DESIGN-SPEC.md § Wordmark + logo.
 */
export interface WordmarkProps {
  className?: string;
  /** True when sitting on an ink/dark surface — ZUPA renders paper instead of ink. */
  inverted?: boolean;
  /** "lockup" = ZUPA + FOR LOGISTICS; "mark" = compact ink square with a paper Z. */
  variant?: "lockup" | "mark";
}

export function Wordmark({ className, inverted = false, variant = "lockup" }: WordmarkProps) {
  const zupaColor = inverted ? "#F7F6F2" : "#12263A";

  if (variant === "mark") {
    return (
      <svg
        viewBox="0 0 44 44"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("w-auto", className)}
        aria-label="Zupa for Logistics"
        role="img"
      >
        <rect x="0" y="0" width="44" height="44" rx="6" fill="#12263A" />
        <text
          x="22"
          y="32"
          textAnchor="middle"
          fontFamily="'Archivo Black', system-ui, sans-serif"
          fontSize="28"
          fill="#F7F6F2"
        >
          Z
        </text>
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 208 56"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("w-auto", className)}
      aria-label="Zupa for Logistics"
      role="img"
    >
      <text
        x="0"
        y="36"
        fontFamily="'Archivo Black', system-ui, sans-serif"
        fontSize="40"
        letterSpacing="0.5"
        fill={zupaColor}
      >
        ZUPA
      </text>
      <text
        x="2"
        y="52"
        fontFamily="'Saira Stencil One', system-ui, sans-serif"
        fontSize="11.5"
        letterSpacing="4.2"
        fill="#D97757"
      >
        FOR LOGISTICS
      </text>
    </svg>
  );
}

export default Wordmark;
